// В мини-аппе БЦК документ не прокручивается: скроллится оболочка .bcc-layout
// (layouts/bcc.vue), поэтому сначала ищем её, а к window откатываемся на обычных страницах
export function getScrollContainer(element?: Element | null): HTMLElement | null {
    const shell = element?.closest?.('.bcc-layout') as HTMLElement | null
    return shell ?? (document.querySelector('.bcc-layout') as HTMLElement | null)
}

export function scrollToAnchor(elementId: string) {
    const anchor = document.getElementById(elementId);
    if (!anchor) {
        return
    }

    const OFFSET = 200
    const container = getScrollContainer(anchor)
    if (container) {
        const anchorPosition = anchor.getBoundingClientRect().top
            - container.getBoundingClientRect().top
            + container.scrollTop
        container.scrollTo({
            top: Math.max(0, anchorPosition - OFFSET),
            behavior: 'smooth'
        })
        return
    }

    // Get the element's position relative to the document
    const anchorPosition = anchor.getBoundingClientRect().top + window.scrollY;

    // Scroll to the element's position with smooth behavior
    window.scrollTo({
        top: anchorPosition - OFFSET, // Adjust the offset as needed
        behavior: 'smooth'
    });
}
